import { UserApi, LoginRequest, LoginResponse, AllLoginRequest } from '@oncampusabroad/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialApiState, ApiCallBase, createApiConfiguration } from './apiConfiguration';

interface LoginCall extends ApiCallBase {
  response: LoginResponse;
}

interface State {
  login: LoginCall;
}

const initialState: State = {
  login: initialApiState,
};

export const loginUser = createAsyncThunk(
  'user/login',
  async (credentials: AllLoginRequest) => {
    try {
      const userApi = new UserApi(createApiConfiguration());
      
      const response = await userApi.login(credentials);
      return response.data;
    } catch (error) {
      console.error('Error logging in:', error);
      throw error;
    }
  }
);

const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetLogin: (state) => {
      state.login = {
        ...initialApiState,
        response: state.login.response,
      };
    },
    resetLoginResponse: (state) => {
      state.login = {
        ...initialApiState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginUser.pending, (state) => {
      state.login.loading = 'pending';
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.login.loading = 'succeeded';
      state.login.response = action.payload;
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.login.loading = 'failed';
      state.login.error = action.payload;
    });
  },
});

export const {
  resetLogin,
  resetLoginResponse,
} = UserSlice.actions;

export default UserSlice.reducer; 